import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../../theme";
import { useState, useEffect } from "react";
import useApi from "../../../shared/hooks/useApi";
import LoadingScreen from "../../../shared/components/LoadingScreen/LoadingScreen";


export default function LumenDashboard() {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [loading, setLoading] = useState(false);
    const [currentMode, setCurrentMode] = useState(null);
    console.log("LumenDashboard");

    const {apiGet, apiPost} = useApi();




    return (
        <Box ml={"40px"} sx={{ justifyContent: "center", display: "flex" }}>
            <Box sx={{
                ml: 2,
                mr: 2,
                minHeight: window.innerHeight - 35,
                width: window.innerWidth,
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>
                {loading && <LoadingScreen loading={loading} />}

                <Box sx={{ mb: 2, width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
                </Box>
                <h1>Lummen Dashboard</h1>

                <Box sx={{ width: '100%', height: 400, mt: 2, mb: 2 }}>
                </Box>
            </Box>
        </Box>
    );
}